import styled from 'styled-components';
import { Form as FormComponent } from '@remix-run/react';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-gqyz44-0"
})(["flex:1;width:100%;display:flex;flex-direction:column;"]);
const Form = styled(FormComponent).withConfig({
  displayName: "style__Form",
  componentId: "sc-gqyz44-1"
})(["flex:1;display:flex;"]);
export { Wrapper, Form };